class MergeCrmRecords {

    records = [];
    selectedRecord = null;

    constructor() 
    {
        this.preventEnterKeySubmit();

        this.fillRecordsArray();

        this.setupRecordsSearchInput();
        this.setupSelectRecordInput();
        this.setupRadioLists();
    }


    preventEnterKeySubmit() 
    {
        const t = this
        $('.prevent-submit').keydown(
            function(event)
            {
                if(event.keyCode == 13) { event.preventDefault(); }
            }
        );
    }


    fillRecordsArray() 
    {
        const t = this;
        $('.selectedRecordInput option').each(function(index, option) {
            t.records[$(option).val()] = $(option).text();
        });
    }

    setupRecordsSearchInput() 
    {
        const t = this;
        $('#recordsSearchInput').on('keyup', function() {

            const searchValue = $(this).val().toLowerCase();
        
            if(searchValue === '') {
                $('.selectedRecordInput option').prop('selected', false);
                t.setSelectedRecodValue(t.records.at(0));
            }
        
            let found = false;
            t.records.forEach((value, recordIndex) => {
                if(!found) 
                {
                    if(value.toLowerCase().indexOf(searchValue) !== -1) 
                    {
                        $('.selectedRecordInput option[value="' + recordIndex + '"]').prop('selected', true);
                        t.setSelectedRecodValue(t.records[recordIndex]);
                        found = true;
                    }
                }
            });

            if(!found) { 
                t.setSelectedRecodValue('');
                $('.selectedRecordInput option').prop('selected', false);
            }
        })
    }

    setupSelectRecordInput() 
    {
        const t = this;
        $('.selectedRecordInput').on('change', 
            function() {
                const recordIndex = $(this).find(':selected').val();
                t.setSelectedRecodValue(t.records[recordIndex]);
            }
        );
    }

    setupRadioLists() 
    {
        $.each(['from', 'to'], (index, value) => {
            const oposite = value === 'from' ? 'to' : 'from';
            $('input[name=' + value + 'RecordPriority]').on('change', function() {
                const otherRadioListVal = $(this).val() === 'main' ? 'side' : 'main';
                $('input[name=' + oposite + 'RecordPriority]').filter('[value=' + otherRadioListVal + ']').prop('checked', true);
            });
        });        
    }





    setSelectedRecodValue(value) 
    {
        this.selectedRecord = value;

        $('#record2').text(value);
        
        if(value !== '') 
        {
            $('#submit-container').show();
            $('#radio2Td').show();
            $('#record2Td').attr('colspan', 1);
            $('#selectRecordSpan').hide();
        }
        else 
        {
            $('#submit-container').hide();
            $('#radio2Td').hide();
            $('#record2Td').attr('colspan', 2);
            $('#selectRecordSpan').show();
        }
    }


}